import { getGenericDefaultData } from '../mockData';
import { EventTypes, IReducerPayload, IConfigurationReducer } from '../types';
import { IReduxAction } from '@core-web/redux';

const genericDefaultData = getGenericDefaultData();

const initialState: IConfigurationReducer = {
  staticMenu: false,
  apiEndpoint: '',
};

export const Reducer = (
  state: IConfigurationReducer = initialState,
  { type, payload }: IReduxAction<EventTypes, IReducerPayload>
): IConfigurationReducer => {
  switch (type) {
    case EventTypes.SET_CONFIGURATION: {
      let shouldShowStaticMenu = false;
      if (payload?.staticMenu?.value) {
        shouldShowStaticMenu = payload?.staticMenu?.value === '1' ? true : false;
      } else {
        shouldShowStaticMenu = genericDefaultData?.staticMenu?.value === '1';
      }
      return {
        ...state,
        staticMenu: shouldShowStaticMenu,
        apiEndpoint: payload?.environment?.value?.toString() || process.env.API_DOMAIN || '',
      };
    }
    default: {
      return state;
    }
  }
};
